const roles = {
    ADMIN: 'ADMIN',
    RUKOVODILAC: 'RUKOVODILAC',
    ZAPOSLENI: 'ZAPOSLENI',
    GOST: 'GOST',
}

export default roles
